// src/catalogueApi.js
//
// Moving the shop's existing data into the dynamic catalogue — see
// functions/migration.js. The `migrateCatalogue` function does the work; this
// only asks for it.
//
// Until the move has run once anyone may start it, signed in or not, which is
// how the storefront sets itself up on the first visit after a deploy. Once it
// has run, asking again (`rerun`) is for admins only.

import axios from 'axios';
import { auth } from './firebase';

// See orderApi.js for why this is the Cloud Run address rather than the alias.
const ENDPOINT = 'https://migratecatalogue-bb4d2hrpta-uc.a.run.app';

/**
 * Runs the move, or answers that it has run. Resolves to
 * `{ status: 'done', report? }` or `{ status: 'in_progress' }`.
 */
export async function setUpCatalogue({ rerun = false } = {}) {
  const token = await auth.currentUser?.getIdToken().catch(() => null);
  try {
    const response = await axios.post(
      ENDPOINT,
      { rerun },
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        // The first run moves every order, which can take a while.
        timeout: 540000,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || error?.message || 'The catalogue could not be moved.'
    );
  }
}
